import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import {  Search } from "lucide-react";

import ConsultationCard from "../../components/Dashboard/Doctor/ConsultationCard";
import ConsultationModal from "../../components/Dashboard/Doctor/ConsultationModal";
import { getAllAIRecords } from "../../services/oprations/aiRecordAPI";

const DoctorManagement = () => {
  const { darkMode } = useOutletContext();
  const [patients, setPatients] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingPatient, setEditingPatient] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const data = await getAllAIRecords();
      setPatients(data); // store raw patients with consultations
    };
    fetchData();
  }, []);

  // const handleAddClick = () => {
  //   setEditingPatient(null);
  //   setIsModalOpen(true);
  // };

  const handleEditClick = (patient) => {
    setEditingPatient(patient);
    setIsModalOpen(true);
  };

  const handleModalSubmit = async (updatedData) => {
    // handle saving patient/consultation here
    setIsModalOpen(false);
  };

  const filteredPatients = patients.filter((p) => {
    const search = searchTerm.toLowerCase();

    const patientId = p?.patient_id?.toLowerCase() || "";
    const matchesPatientId = patientId.includes(search);

    const matchesConsultation = p?.consultations?.some((c) =>
      c?.markdown?.toLowerCase()?.includes(search)
    );

    return matchesPatientId || matchesConsultation;
  });

  return (
    <div className="space-y-6 p-6 animate-fadeInUp">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h1
            className={`text-3xl font-bold ${
              darkMode ? "text-gray-100" : "text-gray-800"
            }`}
          >
            Doctor Management
          </h1>
          <p className={`mt-2 ${darkMode ? "text-gray-300" : "text-gray-600"}`}>
            Manage doctors and their patients
          </p>
        </div>
        {/* <button
          onClick={handleAddClick}
          className="flex items-center justify-center gap-2 px-4 py-2 bg-gradient-to-r from-indigo-500 to-purple-600 text-white font-semibold rounded-lg hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-200"
        >
          <Plus size={20} /> Add New Patient
        </button> */}
      </div>

      <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-200">
        <div className="flex flex-1 relative">
          <Search
            className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
            size={18}
          />
          <input
            type="text"
            placeholder="Search patients or consultations..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-400"
          />
        </div>
      </div>

      {filteredPatients.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
          {filteredPatients.map((patient) => (
            <ConsultationCard
              key={patient._id}
              patient={patient}
              onEdit={handleEditClick}
            />
          ))}
        </div>
      ) : (
        <div
          className={`text-center py-16 rounded-xl border transition-colors duration-300 ${
            darkMode
              ? "bg-gray-800 border-gray-700 text-gray-300"
              : "bg-white border-gray-200 text-gray-500"
          }`}
        >
          <p>No patients found.</p>
        </div>
      )}

      <ConsultationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSubmit={handleModalSubmit}
        initialData={editingPatient}
      />
    </div>
  );
};

export default DoctorManagement;
